import LocalStorageService from '../../../../services/LocalStorageService'
import { setDecorator } from '../decorators/decorators'
import services from '../services'

export default function setVersions (moduleVersionList) {
  const setVersionDecorator = (moduleName, version) => {
    moduleVersionList[moduleName] = version
    setDecorator(moduleName, version)
  }

  const setModulesVersions = (version) => {
    const finalVersion = version || '1.0.0'

    Object.keys(services).forEach((serviceName) => setVersionDecorator(serviceName, finalVersion))
    LocalStorageService.setCurrentVersion(finalVersion)

    setVersionDecorator('users', '1.5.3')
    // Users Hardcoded pois atualmente todos os Tenants utilizam o /users do clientprefix 'senior'
  }

  if (LocalStorageService.getClientPrefix()) {
    services.clients.about()
      .then(({ data: version }) => {
        setModulesVersions(version)
      })
      .catch(() => {
        console.log('Failed to get APP_VERSION. Defaulting to Legacy Interface.')
        setModulesVersions('')
      })
  } else {
    console.log('Awaiting clientPrefix')
  }
}
